import React from 'react'
import { renderVideo } from '../../../../SectionElements/plugins/utils'

const PreviewVideo = ({version_content}) => {
  const { short_description, video_url } = version_content
  
  // Use video_label if available, otherwise construct it
  const videoLabel = version_content.video_label || version_content.pageTitle || 'Video'
  
  // Create a proper video object for renderVideo
  // renderVideo expects either { video_url: 'url' } or { video: { url: 'url' } }
  const videoData = {
    video_url: video_url,
    // Don't pass the empty video object
  }
  
  const videoElement = renderVideo(videoData)
  return (
    <div>
      <div style={{ padding: '20px' }}>
        {/* Video Header */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            marginBottom: '20px',
            paddingBottom: '20px',
            borderBottom: '3px double #e0e0e0',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <input type="checkbox" defaultChecked={true} readOnly disabled />
            <h2 style={{ margin: 0, fontSize: '23px' }}>{videoLabel}</h2>
          </div>
        </div>

        {/* Video Player */}
        {videoElement ? (
          videoElement
        ) : (
          <div style={{ marginLeft: '4px', marginTop: '10px', color: '#888' }}>
            <p>⚠️ No video to display</p>
            <p style={{ fontSize: '12px' }}>Debug: version_content = {JSON.stringify(version_content)}</p>
          </div>
        )}

        {/* Video URL */}
        {video_url && (
          <div style={{ marginLeft: '4px', marginTop: '10px' }}>
            <p>{video_url}</p>
          </div>
        )}

        {/* Short Description */}
        {short_description && (
          <div style={{ marginLeft: '4px', marginTop: '10px' }}>
            <p style={{ whiteSpace: 'pre-wrap' }}>{short_description}</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default PreviewVideo